<template>
  <base-auth>
    <div class="kt-login__form">
      <form @submit.prevent="onSubmit" id="change_pass_form" class="kt-form">
        <vue-recaptcha
          v-if="captchaDriver === 'recaptcha'"
          ref="resetPassword"
          @verify="onVerify"
          @expired="onExpired"
          size="invisible"
          :sitekey="sitekey"
          :loadRecaptchaScript="true">
        </vue-recaptcha>
        
        <arcaptcha-vue
          v-if="captchaDriver === 'arcaptcha'"
          ref="arcaptchaReset"
          :site_key="arCaptchaKey"
          :invisible="true"
          :callback="onArcaptchaSuccess"
          :expired_callback="onArcaptchaExpired"
          :error_callback="onArcaptchaError"
        />
        
        <kt-form-group>
          <kt-form-control
            type="password"
            :placeholder="$t('auth.placeholder.password')"
            name="password"
            id="password"
            v-model="password"
          >
          </kt-form-control>
        </kt-form-group>
        <kt-form-group>
          <kt-form-control
            type="password"
            :placeholder="$t('auth.placeholder.password_confirm')"
            name="password_confirm"
            id="password_confirm"
            v-model="password_confirm"
          >
          </kt-form-control>
        </kt-form-group>
        <div class="kt-login__actions">
          <kt-button type="submit" id="change_pass_submit" variant="brand" class="btn-pill btn-elevate">
            {{ $t('auth.btn.reset_pass') }}
          </kt-button>
        </div>
      </form>
    </div>
  </base-auth>
</template>

<script>
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {authService} from "@/common/api.service";
import VueRecaptcha from "vue-recaptcha";
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import ArcaptchaVue from 'arcaptcha-vue'

export default {
  name: "ResetPassword",
  props: {
    code: String,
    phone: String
  },
  data() {
    return {
      password: "",
      password_confirm: "",
      sitekey: reCaptchaKeys,
      arCaptchaKey: arCaptchaKeys,
      captchaDriver: getCaptchaDriver,
      g_recaptcha_response: '',
      arcaptchaToken: '',
      login_event: null,
      recaptcha_verified: false,
      arcaptchaVerified: false,
    }
  },

  components: {
    VueRecaptcha,
    ArcaptchaVue
  },

  methods: {
    onSubmit: function (e) {
      this.login_event = e;
      this.executeCaptcha();
    },
    
    executeCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.resetPassword.execute();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
        this.$refs.arcaptchaReset.execute();
      }
    },
    
    onVerify(response) {
      this.recaptcha_verified = true;
      this.g_recaptcha_response = response;
      this.changePass(this.login_event);
    },
    
    onExpired() {
      this.recaptcha_verified = false;
    },
    
    onArcaptchaSuccess(token) {
      this.arcaptchaToken = token;
      this.arcaptchaVerified = true;
      this.changePass(this.login_event);
    },
    
    onArcaptchaExpired() {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
    },
    
    onArcaptchaError(error) {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
      this.showMsg('danger', 'Captcha verification failed. Please try again.');
    },
    
    resetCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.resetPassword && this.$refs.resetPassword.reset();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.$refs.arcaptchaReset && this.$refs.arcaptchaReset.reset();
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
      }
    },
    
    isCaptchaVerified() {
      if (this.captchaDriver === 'recaptcha') {
        return this.recaptcha_verified;
      } else if (this.captchaDriver === 'arcaptcha') {
        return this.arcaptchaVerified && this.arcaptchaToken;
      }
      return false;
    },
    
    getCaptchaResponse() {
      if (this.captchaDriver === 'recaptcha') {
        return this.g_recaptcha_response;
      } else if (this.captchaDriver === 'arcaptcha') {
        return this.arcaptchaToken;
      }
      return '';
    },
    
    changePass() {
      let btn = $('#change_pass_submit')
      let form = $('#change_pass_form')
    
      form.validate({
        ignore: ".ignore",
        rules: {
          password: {
            minlength: 5
          },
          password_confirm: {
            minlength: 5,
            equalTo: "#password"
          }
        }
      })
    
      if(!form.valid()) {
        return
      }
    
      if (!this.isCaptchaVerified()) {
        return;
      }
    
      let params = {
        phone: this.phone,
        code: this.code,
        password: this.password,
        password_confirm: this.password_confirm,
      }
    
      if (this.captchaDriver === 'recaptcha') {
        params['g-recaptcha-response'] = this.g_recaptcha_response;
      } else if (this.captchaDriver === 'arcaptcha') {
        params['g-recaptcha-response'] = this.arcaptchaToken;
      }
    
      KTApp.progress(btn)
    
      authService.changePass(params)
        .then(response => {
          this.showMsg('success', response.data.message)
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500)
        })
        .catch((error) => {
          if (error.response.data && error.response.data.message) {
            this.showMsg(form, 'danger', error.response.data.message);
          } else if (error.response.data.data) {
            form.validate().showErrors(error.response.data.data);
          } else {
            this.showMsg(form, 'danger', 'An unexpected error occurred. Please try again.');
          }

        })
        .finally(() => {
          KTApp.unprogress(btn)
          this.resetCaptcha()
        })
    },
    
    showMsg(form, type, message) {
       // Implementation for showing messages
       console.log(`${type}: ${message}`);
    
         form.find('.alert').remove();
       
       let alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
       let alertHtml = `
         <div class="alert ${alertClass} alert-dismissible fade show" role="alert">
           <div class="alert-text">${message}</div>
           <button type="button" class="close" data-dismiss="alert" aria-label="Close">
             <span aria-hidden="true">&times;</span>
           </button>
         </div>
       `;
        
       form.prepend(alertHtml);
        
       setTimeout(() => {
         form.find('.alert').fadeOut(300, function() {
           $(this).remove();
         });
      }, 8000);
    }
  }
}
</script>

<style scoped>
.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-dismissible {
  padding-right: 35px;
}

.alert .close {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0;
  background: transparent;
  border: none;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
}

.alert .close:hover {
  opacity: 0.75;
}
</style>